// custom typefaces
import 'typeface-merriweather';

import 'prismjs/themes/prism-dark.css';
import 'prismjs';

// custom stylesheet
import './src/styles/global.sass';
